import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from "prop-types";

const slug = {
  es: ['ferries-desde-alicante', 'ferries-desde-barcelona', 'ferries-a-oran', 'ferries-a-mostaganem', 'ferries-a-argel',],
  fr: ['ferries-d-alicante', 'ferries-d-barcelona', 'ferries-a-oran', 'ferries-a-mostaganem', 'ferries-a-argel']
}

class sectionCities extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  onClick = (to) => {
    this.context.router.history.push(to)
    window.scrollTo(0, 0)
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].cities

    const path = this.context.router.route.location.pathname
    const lang = path.split('/')[1]
    return (
      <div>

        <div className="container-fluid">

          <section className="section-cities row">
            <div className="alicante city col-md-6 cover" onClick={() => this.onClick(`/${lang}/${slug[lang][0]}`)}>
              <div className="city-content">
                <h3 className="h3 no-margin heavy"><p className="small-title light">{langPlace.ferrysa}</p>{langPlace.alicante}</h3>
              </div>
            </div>
            <div className="barcelona city col-md-6 cover" onClick={() => this.onClick(`/${lang}/${slug[lang][1]}`)}>
              <div className="city-content">
                <h3 className="h3 no-margin heavy"><p className="small-title light">{langPlace.ferrysa}</p>{langPlace.barcelona}</h3>
              </div>
            </div>
          </section>

        </div>
        <div className="container-fluid">

          <section className="section-cities row">
            <div className="oran city col-md-4 cover" onClick={() => this.onClick(`/${lang}/${slug[lang][2]}`)}>
              <div className="city-content">
                <h3 className="h3 no-margin heavy"><p className="small-title light">{langPlace.ferrysb}</p>{langPlace.oran}</h3>
              </div>
            </div>
            <div className="argel city col-md-4 cover" onClick={() => this.onClick(`/${lang}/${slug[lang][4]}`)}>
              <div className="city-content">
                <h3 className="h3 no-margin heavy"><p className="small-title light">{langPlace.ferrysb}</p>{langPlace.argel}</h3>
              </div>
            </div>
            <div className="mostaganen city col-md-4 cover" onClick={() => this.onClick(`/${lang}/${slug[lang][3]}`)}>
              <div className="city-content">
                <h3 className="h3 no-margin heavy"><p className="small-title light">{langPlace.ferrysb}</p>{langPlace.mostaganem}</h3>
              </div>
            </div>
          </section>

        </div>
        <div className="clearfix"></div>

      </div>
    );
  }
}

export default connect(
	(state) => ({settings: state.settings})
)(sectionCities)



// WEBPACK FOOTER //
// ./src/shared/routes/routeHome/components/sectionCities.js